import axios, { AxiosPromise } from 'axios';
import { OnRequestSuccess, OnRequestError } from '../services/Responses';

export class FileUploadService {
    constructor() {

    }

    public UploadFiles(
        url: string,
        files: File[],
        additionalData: any,
        onSuccess: OnRequestSuccess,
        onError: OnRequestError) {

        let formData = new FormData();
        for (let file of files) {
            formData.append('files', file);
        }
        if (additionalData) {
            for (let key of Object.keys(additionalData)) {
                formData.append(key, additionalData[key]);
            }
        }
        this.Post(url, formData, onSuccess, onError);
    }

    private HttpPost(url: string, data: any): AxiosPromise<any> {
        return axios.post('./' + url, data, {
            onUploadProgress: (evt: ProgressEvent) => {
                console.log('Progress: ' + Math.round(evt.loaded / evt.total * 100) + '%');
                console.log(evt);
            }
        });
    }

    private Post(url: string, data: any, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.HttpPost(url, data).then(res => {
            onSuccess(res);
        }).catch(error => {
            onError(error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/FileUploadService.tsx